module.exports = __webpack_public_path__ + "img/calendar-pen.09724ed3.svg";